import {
  AccountName,
  AccountNumber,
  Address1,
  Address2,
  Address3,
  AddressHeading,
  BankName,
  BranchName,
  ContactDescription,
  ContactUs,
  Donate,
  Email,
  IFSC,
  IfscCode,
  Phone1,
  Phone2,
  Phone3,
} from "../../constants";

import qrcode from "../../img/qrcode.png";
import useMediaQuery from "../../utils/media-query";

const Contact: React.FC<{}> = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  const styles = {
    width: isMobile ? "100%" : "20%",
  };

  return (
    <div>
      {" "}
      <section id="contact">
        <div className="container">
          <div className="section-header">
            <h3>{ContactUs}</h3>
            <p>{ContactDescription}</p>
          </div>

          <div className="row contact-info">
            <div className="col-md-4" style={styles}>
              <div className="contact-address">
                <h3>{AddressHeading}</h3>
                <address>
                  {Address1}
                  <br />
                  {Address2}
                  <br />
                  {Address3}
                </address>
              </div>
            </div>

            <div className="col-md-4" style={styles}>
              <div className="contact-phone">
                <h3>Phone Number</h3>
                <p>
                  {Phone1} <br></br>
                  {Phone2}
                  <br></br> {Phone3}
                </p>
              </div>
            </div>

            <div className="col-md-4" style={styles}>
              <div className="contact-email">
                <h3>Email</h3>
                <p>{Email}</p>
              </div>
            </div>

            <div className="col-md-4" style={styles}>
              <div className="contact-donation">
                <h3>{Donate}</h3>
                <img
                  src={qrcode}
                  alt=""
                  style={{ width: "35%", height: "auto" }}
                />
              </div>
            </div>

            <div className="col-md-4" style={styles}>
              <div className="contact-bank">
                <h3>Bank Details</h3>
                <p>
                  {AccountName} {AccountNumber}
                  <br></br>
                  {IFSC} {IfscCode}
                  <br></br>
                  {BankName}
                  <br></br>
                  {BranchName}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
